import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { MachineRouteService } from '../machine-route.service';
import { InventoryHttpService } from '../../../../core/inventory';
import { MixpanelService } from '../../../../services/mixpanel.service';
import { mapApiProductNameToDisplayName } from '../../../../core/_config/product.constants';

@Component({
  selector: 'kt-inventory-location',
  templateUrl: './inventory-location.component.html',
  styleUrls: ['./inventory-location.component.scss']
})
export class InventoryLocationComponent implements OnInit {

	selectedMachine: any;

	inventory;

	oldInventory;

	// inventory = [
	// 	{
	// 		name: "BEANS",
	// 		prodId: 1,
	// 		slotNo: 1,
	// 		siteBagCnt: 2,
	// 	},
	// 	{
	// 		name: "FV CREAM",
	// 		prodId: 2,
	// 		slotNo: 2,
	// 		siteBagCnt: 1,
	// 	},
	// 	{
	// 		name: "COCOA",
	// 		prodId: 3,
	// 		slotNo: 3,
	// 		siteBagCnt: 4,
	// 	},
	// 	{
	// 		name: "MILK",
	// 		prodId: 4,
	// 		slotNo: 4,
	// 		siteBagCnt: 4,
	// 	},
	// 	{
	// 		name: "CHAI",
	// 		prodId: 5,
	// 		slotNo: 5,
	// 		siteBagCnt: 0,
	// 	},
	// 	{
	// 		name: "COCCONUT",
	// 		prodId: 6,
	// 		slotNo: 6,
	// 		siteBagCnt: 1,
	// 	}
	// ];

  constructor(private http: InventoryHttpService, private cdr: ChangeDetectorRef, private _snackBar: MatSnackBar, private mixpanelService: MixpanelService, private route: ActivatedRoute, private machineRouteService: MachineRouteService) { }

  ngOnInit() {
	this.selectedMachine = this.machineRouteService.getMachine(this.route);
	if (!this.selectedMachine) return;
	this.getMacLocInv();
	this.mixpanelService.track(this.mixpanelService.PAGE_VIEW,
	{
		'Machine ID': this.selectedMachine.machine_id,
		'Machine Name': this.selectedMachine.machine_name,
		'Machine Serial No': this.selectedMachine.serial_no
	}
	);

  }

  getMacLocInv(){
	this.http.getMachineLocInventory({machine_id: this.selectedMachine.machine_id})
	.subscribe(inv => {
		this.oldInventory = JSON.stringify(inv);
		this.inventory = inv;
		let beansObj;
		if(this.inventory[this.inventory.length-1].prodName == "BEANS") {
			beansObj = this.inventory.pop();
			this.inventory.unshift(beansObj);
		}
		console.log(this.inventory);
		this.cdr.detectChanges();
	});
  }

  submit(){
	if(this.oldInventory == JSON.stringify(this.inventory)){
		this.showSnackBar("No changes detected", 3000);
	}else{
		this.http.updateMacLocInv(this.inventory)
		.then(res => {
			if(res.success){
				this.showSnackBar("Updated Successfully", 2000);
			}else{
				this.showSnackBar("Unable to Update", 0);
			}
		})
		.catch(err => {
			if(err.message){
				this.showSnackBar(err.message, 0);
			} else {
				this.showSnackBar("An error occurred. Unable to Update!!!", 0);
			}
		});
	}
  }

  showSnackBar(message: string, duration: number) {
	let snackRef = this._snackBar.open(message, 'close');
	if (duration > 0) {
		setTimeout(() => {
			this._snackBar.dismiss();
		}, duration);
	}

	snackRef.onAction().subscribe(() => {
		this._snackBar.dismiss();
	});
}

  getProductDisplayName(prodName: string): string {
	return mapApiProductNameToDisplayName(prodName);
}

}
